//default from angular libraries
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import classes
import { LoginInputCls } from '../classes/login/login_input';
import { LoginOutputCls } from '../classes/login/login_output';

@Injectable({ providedIn: 'root' })

export class SuperadminAuthService {

    private loginUrl = AppSettings.API_ENDPOINT+AppBackRoutes.SUPER_ADMIN;
    private permissionUrl = AppSettings.API_ENDPOINT+AppBackRoutes.SPERMISSION_SERVICE;
    
    constructor(
        private http: HttpClient,
        private router: Router,
    ) { }
    
    public login(Logininput : LoginInputCls) {
		return this.http.post<LoginOutputCls>(this.loginUrl, Logininput)
		.pipe(
            map((res: LoginOutputCls) => {
                localStorage.setItem('user_key', res.data.user_key);
				return res;
			})
		);
	}

	public logout() {
        localStorage.removeItem("user_key");
        this.router.navigate(["/"]);
    }

    public user_key()
    {
        return localStorage.getItem('user_key');
    }

    public update_user_key(user_key) {
        localStorage.setItem('user_key', user_key);   
    }
    
	public isLoggedIn() {

        var user_key = localStorage.getItem('user_key');
        return (user_key) ? true : false;
    }

    public isLoggedOut() {
        return !this.isLoggedIn();
    }
    
    public permission()
    {
        return this.http.get(this.permissionUrl);
    }

}